import { render } from "./App.vue?vue&type=template&id=7096b735&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7096b735&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7096b735"

export default script